if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

async onSubmitHandler(evt) {

      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      // Confirmation for Complete Hard House Sample Pack #2 only
const selectedVariantId = this.form.querySelector('[name="id"]').value;

if (selectedVariantId === '55382332080457') {
  if (this.volumePopupOpen) return;
  this.volumePopupOpen = true;

  let confirmed = false;

  try {
    confirmed = await new Promise((resolve) => {
      const previousFocus = document.activeElement;
      const popup = document.createElement('dialog');

      popup.setAttribute('aria-labelledby', 'sw-volume-title');
      popup.setAttribute('aria-describedby', 'sw-volume-description');
      popup.style.cssText =
        'width:calc(100% - 32px);max-width:460px;box-sizing:border-box;' +
        'padding:30px;border:1px solid #444;border-radius:16px;' +
        'background:#151515;color:#fff;font-family:inherit;';

      popup.innerHTML = `
        <style>
          .sw-volume-popup::backdrop {
            background: rgba(0, 0, 0, 0.75);
          }
          .sw-volume-popup button,
          .sw-volume-popup a {
            box-sizing: border-box;
            display: block;
            width: 100%;
            padding: 14px;
            border-radius: 8px;
            font: inherit;
            font-weight: 600;
            text-align: center;
            text-decoration: none;
            cursor: pointer;
          }
          .sw-volume-popup button:focus-visible,
          .sw-volume-popup a:focus-visible {
            outline: 3px solid #aaa;
            outline-offset: 3px;
          }
        </style>
        <div style="text-align:right">
          <button type="button" data-close aria-label="Close"
            style="width:auto;display:inline-block;padding:4px 10px;
            background:transparent;border:0;color:#fff;font-size:24px">
            ×
          </button>
        </div>
        <h2 id="sw-volume-title"
          style="margin:0 0 16px;color:#fff;font-size:24px">
          This is Hard House Pack #2
        </h2>
        <p id="sw-volume-description"
          style="margin:0 0 24px;line-height:1.6;color:#ddd">
          New to our Hard House series? We recommend starting with Pack #1.
        </p>
        <button type="button" data-continue
          style="background:#fff;color:#111;border:1px solid #fff">
          Continue with Pack #2
        </button>
        <a href="/products/complete-hard-house-sample-pack-1"
          style="margin-top:12px;background:transparent;
          color:#fff;border:1px solid #666">
          Check out Pack #1 first
        </a>
      `;

      popup.className = 'sw-volume-popup';

      const finish = (proceed) => {
        popup.close();
        popup.remove();

        if (previousFocus && previousFocus.isConnected) {
          previousFocus.focus();
        }

        resolve(proceed);
      };

      popup.querySelector('[data-continue]').onclick = () => finish(true);
      popup.querySelector('[data-close]').onclick = () => finish(false);

      popup.addEventListener('cancel', (event) => {
        event.preventDefault();
        finish(false);
      });

      document.body.appendChild(popup);
      popup.showModal();
      popup.querySelector('[data-continue]').focus();
    });
  } finally {
    this.volumePopupOpen = false;
  }

  if (!confirmed) return;
}

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            document.dispatchEvent(
              new CustomEvent("cart:error", {
                detail: {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.description,
                  message: response.message,
                },
              })
            );
            // -------------------------------------------
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

           // VARIANT ADDED EVENT
           document.dispatchEvent(
            new CustomEvent("variant:add", {
              detail: {
                variant: {
                  id: formData.get("id"),
                },
                quantity: Number(formData.get("quantity") || 1),
                formElement: this.form,
                sectionId: this.dataset.source,
              },
            })
          );
          // -------------------------------------------

          fetch(`${routes.cart_url}.js`)
						.then((response) => {
							return response.text()
						})
						.then((state) => {
							const parsedState = JSON.parse(state)

							// dispatch cart:change for the entire basket
							document.dispatchEvent(
								new CustomEvent('cart:change', {
									detail: {
										cart: parsedState,
										sectionId: this.dataset.source,
									},
								})
							)
							// dispatch cart:change for the entire basket

						})
						.catch((error) => {
							console.error('Error fetching cart state:', error);
						})

          if (!this.error){
             publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
               productVariantId: formData.get('id')
              });
            }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
